<mat-expansion-panel class="panel">
  <mat-expansion-panel-header>
    <mat-panel-title> {{ 'ASSOCIATIONS.FULFILLMENT_PROJECTS.TITLE' | translate }} </mat-panel-title>
  </mat-expansion-panel-header>
  @if (hasItems$ | async) {
    @for (item of items$ | async; track item.id) {
      <mat-card appearance="outlined" class="card">
        <mat-card-header class="card-header">
          <mat-card-title class="card-title">
            <a [routerLink]="item.url">
              {{ item.title }}
            </a>
          </mat-card-title>
          <mat-card-subtitle>
            {{ item.subtitle.label | translate }}: {{ item.subtitle.date | date: 'mediumDate' }}
          </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content class="card-content">
          <glxy-badge [color]="item.badge.color">
            {{ item.badge.label | translate }}
          </glxy-badge>
        </mat-card-content>
      </mat-card>
    }
    @if (hasMore$ | async) {
      <button mat-button color="primary" class="show-more-button" (click)="handleShowMoreClick()">
        <mat-icon>add</mat-icon>
        {{ 'ASSOCIATIONS.ACTIONS.SHOW_MORE' | translate: { count: pageSize } }}
      </button>
    }
    @if (showViewAllAction) {
      <button mat-stroked-button color="primary" class="bottom-action-button" (click)="handleViewAllClick()">
        {{ 'ASSOCIATIONS.ACTIONS.VIEW_ALL' | translate }}
      </button>
    }
  } @else {
    <div class="empty">
      {{ 'ASSOCIATIONS.FULFILLMENT_PROJECTS.NO_PROJECTS' | translate }}
    </div>
  }
</mat-expansion-panel>
